import Index from '../components/Divergences/Index'


let routes = {
    path: '/divergences',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/divergences',
            name: 'Não conformidades',
            component: Index,
        },

    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/divergences.js